import {DesignerTab} from "../../constants/designerTab";

export const checkIsVisibleSorting = (tabIndex: string) => {
    return [DesignerTab.students,
        DesignerTab.author,
        DesignerTab.workingMaterials,
        DesignerTab.coauthor,
        DesignerTab.books,
        DesignerTab.presentations,
        DesignerTab.rejected,
        DesignerTab.subscribe,
        DesignerTab.games_archive].includes(tabIndex as DesignerTab)
}import {DesignerTab} from "../../constants/designerTab";

export const checkIsVisibleSorting = (tabIndex: string) => {
    return [DesignerTab.students,
        DesignerTab.author,
        DesignerTab.workingMaterials,
        DesignerTab.coauthor,
        DesignerTab.books,
        DesignerTab.presentations,
        DesignerTab.rejected,
        DesignerTab.subscribe,
        DesignerTab.games_archive].includes(tabIndex as DesignerTab)
}